export enum LegacyExamRequestStatus {
  PendingApproval = 'PENDING_APPROVAL',
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  PendingReassignment = 'PENDING_REASSIGNMENT',
}

export const LEGACY_EXAM_REQUEST_STATUS_LABELS: Record<LegacyExamRequestStatus, string> = {
  [LegacyExamRequestStatus.PendingApproval]: 'Pending approval',
  [LegacyExamRequestStatus.PendingAcceptance]: 'Pending acceptance',
  [LegacyExamRequestStatus.PendingReassignment]: 'Pending reassignment',
};
